export const getAnimationVariants = (isFirstRender: boolean) => ({
  'slide-bottom-to-top': {
    initial: {
      y: isFirstRender ? 0 : '100%',
    },
    animate: {
      y: 0,
    },
    exit: {
      y: '-100%',
    },
  },
});